import styled from '@emotion/styled';
import {
  HeadingText50,
  BodyTextMedium,
  DeprecatedButton as Button,
} from '@modernhealth/vital-components';

import { ReactComponent as NotFound } from '../assets/not-found.svg';

const Wrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  maxWidth: 493,
});

const NotFoundPage = (): JSX.Element => {
  return (
    <Wrapper>
      <Container>
        <div css={{ marginBottom: 22 }}>
          <NotFound />
        </div>
        <HeadingText50 as="h2" css={{ textAlign: 'center' }} fontColor="gray85">
          We couldn’t connect the dots
        </HeadingText50>
        <BodyTextMedium css={{ marginBottom: 22, textAlign: 'center' }} fontColor="gray65">
          This page was not found. You may have mistyped the address or the page may have moved.
        </BodyTextMedium>
        <Button size="large" variant="secondary" title="Take me to Circles" to="/" />
      </Container>
    </Wrapper>
  );
};

export default NotFoundPage;
